import { render, staticRenderFns } from "./WelcomeBanner.vue?vue&type=template&id=6b267762&scoped=true&"
import script from "./WelcomeBanner.vue?vue&type=script&lang=ts&"
export * from "./WelcomeBanner.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeBanner.vue?vue&type=style&index=0&id=6b267762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b267762",
  null
  
)

export default component.exports